// RightClickMenu.js
import React from 'react';
import {
    Box,
    Menu,
} from '@mui/material';

export default function RightClickMenu(props) {
    const {
        children,
        content,
        handleClose,
        handleContextMenu,
        menuPosition
    } = props

    return (
        <>
            <div onContextMenu={handleContextMenu}>
                {children}
            </div>
            {
            content && menuPosition && (
            <Menu
                anchorReference='anchorPosition'
                anchorPosition={
                    menuPosition !== null
                    ?
                        {
                            top: menuPosition.mouseY,
                            left: menuPosition.mouseX
                        }
                    :
                        undefined
                }
                onClose={handleClose}
                open={menuPosition !== null}
                slotProps={{
                    'paper': {
                        style: {
                            color: 'white',
                            maxHeight: '400px',
                            background: 'rgba(48, 89, 69, 0.7)',
                            backdropFilter: 'blur(20px)',
                        }
                    }
                }}
            >
                <Box
                    sx={{
                        width: 250
                    }}
                >
                    { content }
                </Box>
            </Menu>
            )}
        </>
    );
}